import { NAME as APP_NAME } from '../constants';

export const NAME = `${APP_NAME}/CREDIT_CARDS`;

export const REDUCER_NAME = 'creditCards';
